import { loadReoScript } from 'reodotdev';

const CLIENT_ID = "151dc5b0493a177";

let reoPromise: Promise<any> | null = null;


export const initReo = () => {
  if (!reoPromise) {
    reoPromise = loadReoScript({ clientID: CLIENT_ID })
      .then(Reo => {
        Reo.init({ clientID: CLIENT_ID });
        return Reo;
      })
      .catch(error => {
        console.error('Error loading Reo', error);
        return null;
      });
  }

  return reoPromise;
};

interface ReoIdentifyOptions {
    username: string;
    type: 'linkedin' | 'github' | 'email';
    other_identities?: { username: string; type: string }[];
    firstname?: string;
    lastname?: string;
    company?: string;
}

export const identifyUser = async (identity: ReoIdentifyOptions) => {
  const Reo = await initReo();
  if (Reo) {
    Reo.identify(identity);
  }
};
